import { applyMiddleware, createStore } from 'redux';
import flightReducer from './flight/flightReducer';
import validationMiddleware from './middlewares/flightValidation';

const store = createStore(flightReducer, applyMiddleware(validationMiddleware));

export default store;